/** User-supplied SC-CAP-UX05 reading content. Never a formal capability mapping. */
export const issueContexts = {
  schema: 'SC-CAP-UX05-context-v1',
  notice: '精确保留森林19条与高层19条候选关联；实施时先与当前主干映射比对，不直接覆盖冻结内容',
  forest: [
    {
      issueKey: 'FOREST-ISSUE-01',
      title: '火情线索与早期核实',
      description:
        '卫星热点、山林烟点、视频告警或巡护报告都是需要核实的火情线索。要先明确线索的时间、位置和来源，再比对其他观察，不应直接当成已经发生的森林火灾。',
      capabilities: [
        {
          key: 'CAP-SIGNAL',
          purpose:
            '把卫星热点、视频告警和巡护报告按观测时间、坐标与来源并列，辅助发现需要进一步核查的位置。',
          output: '多源线索对照清单与待核实信息',
          formalCapabilityId: null,
        },
        {
          key: 'CAP-AIR',
          purpose: '在具备巡查条件及授权时，从空中补充疑似烟点附近的观察画面。',
          output: '带时间和位置的空中观察记录',
          formalCapabilityId: null,
        },
        {
          key: 'CAP-VIDEO',
          purpose: '调阅固定视频或瞭望记录，对照疑似烟点出现时刻和方向。',
          output: '远距离可见光或合适配置的热像观测线索',
          formalCapabilityId: null,
        },
        {
          key: 'CAP-COMMS',
          purpose: '把地面核查人员的确认或否认结果回传给研究与指挥信息整理端。',
          output: '带来源与时间的核实反馈',
          formalCapabilityId: null,
        },
      ],
    },
    {
      issueKey: 'FOREST-ISSUE-02',
      title: '气象与火势变化条件',
      description:
        '风速风向、温度、湿度、降水和植被情况会影响森林火险信息的理解。应将数据的地点、时间与测量方式一起展示，不能由单个天气值直接推导火险等级。',
      capabilities: [
        {
          key: 'CAP-METEO',
          purpose: '记录与疑似火情地点和时刻有关的风、温湿度与降水信息，并区分预报和实测。',
          output: '带时间地点的环境条件资料',
          formalCapabilityId: null,
        },
        {
          key: 'CAP-MULTISOURCE',
          purpose: '按时间对照林区多次观察画面与气象记录，提示变化是否具有共同背景。',
          output: '变化对照视图与待解释差异',
          formalCapabilityId: null,
        },
        {
          key: 'CAP-AIR',
          purpose: '在允许开展巡查时补充不同时间的外部画面，但不据此自动推算火势扩散速度。',
          output: '连续时间点的外部观察图像',
          formalCapabilityId: null,
        },
      ],
    },
    {
      issueKey: 'FOREST-ISSUE-03',
      title: '地形道路与重点保护对象',
      description:
        '山脊、沟谷、道路和周边村镇影响地理信息的理解与现场资料收集。地图上的道路、河流和居民点只是基础信息，不能当作实时可通行或已完成核实。',
      capabilities: [
        {
          key: 'CAP-GEO',
          purpose: '查阅林区山脊沟谷、河流和道路分布，明确资料更新时间。',
          output: '位置关系图与需现场核实的通行项',
          formalCapabilityId: null,
        },
        {
          key: 'CAP-AIR',
          purpose: '从空中观察地图信息可能无法反映的道路障碍或地形状况。',
          output: '有时间的外围地形和道路画面',
          formalCapabilityId: null,
        },
        {
          key: 'CAP-VIDEO',
          purpose: '使用可用瞭望或视频画面关注重点保护对象周边的可观察情况。',
          output: '已有监控覆盖区域的观察记录',
          formalCapabilityId: null,
        },
      ],
    },
    {
      issueKey: 'FOREST-ISSUE-04',
      title: '人员安全与疏散线索',
      description:
        '森林火灾可能影响林区工作人员、周边居民、游客及其他人员。平台应列出需要了解的位置、联络与通行信息，不自动生成撤离路线或作战指令。',
      capabilities: [
        {
          key: 'CAP-PERSON',
          purpose: '整理巡护人员和周边人员的报告，区分未经核实的线索与已确认联络。',
          output: '人员线索登记与反馈状态',
          formalCapabilityId: null,
        },
        {
          key: 'CAP-COMMS',
          purpose: '为不同联络对象提供已知的语音或数据通路信息，显示联系尝试结果。',
          output: '联络状态与沟通记录',
          formalCapabilityId: null,
        },
        {
          key: 'CAP-GEO',
          purpose: '结合已有地形道路资料标记需要专业核查的人口聚落和设施位置。',
          output: '位置关系和待核查对象清单',
          formalCapabilityId: null,
        },
      ],
    },
    {
      issueKey: 'FOREST-ISSUE-05',
      title: '林区通信与信息回传',
      description:
        '偏远林区的地形、供电条件和网络覆盖可能使联络与视频回传受限。需要掌握有哪些通路、谁能联系谁、视频与定位能否按预期送达。',
      capabilities: [
        {
          key: 'CAP-COMMS',
          purpose: '识别现场设备、巡护人员与后方之间已有的通信方式，核对是否近期测试。',
          output: '联系对象、链路类型和测通结果',
          formalCapabilityId: null,
        },
        {
          key: 'CAP-RELAY',
          purpose: '在原有网络不足时研究卫星地面站、中继设备等替代通路的适用条件。',
          output: '不同通信方案的覆盖假设和测试记录',
          formalCapabilityId: null,
        },
        {
          key: 'CAP-AIR',
          purpose: '在获准条件下配合空中设备采集巡护画面，并研究能否可靠回传。',
          output: '带时间的观察视频与传输记录',
          formalCapabilityId: null,
        },
      ],
    },
    {
      issueKey: 'FOREST-ISSUE-06',
      title: '火源风险与日常巡护',
      description:
        '森林防火大量工作发生在事故之前。日常应关注火源活动、巡护覆盖、重点防火区域与相关规则，并记录线索来源及最新更新时间。',
      capabilities: [
        {
          key: 'CAP-PATROL',
          purpose: '整理各巡护区域的时间、路线、问题与处理记录，为长期复查提供线索。',
          output: '巡护台账与待处理问题记录',
          formalCapabilityId: null,
        },
        {
          key: 'CAP-VIDEO',
          purpose: '结合已有视频监控和瞭望资料关注进山入口、重点林段的可见异常。',
          output: '有来源和时间的视频观察条目',
          formalCapabilityId: null,
        },
        {
          key: 'CAP-SIGNAL',
          purpose: '把公众报告、巡护发现和官方历史案例中的火源风险类型归档，不自动认定违法行为。',
          output: '火源风险分类和待核实线索',
          formalCapabilityId: null,
        },
      ],
    },
  ],
  highrise: [
    {
      issueKey: 'HR-ISSUE-01',
      title: '烟气蔓延',
      description:
        '关注竖向与水平空间的连通情况及烟气的可见线索；信息需求不等于本次事故已经获得的报告。',
      capabilities: [
        {
          key: 'HR-SMOKE',
          purpose:
            '在「烟气蔓延」问题中，通过建筑原有防烟排烟设施或合适的便携通风设备，为烟气控制提供物理作用和相关状态信息。',
          output: '哪些方式影响烟气控制及其适用边界的说明，而不是直接给出排烟指令',
          formalCapabilityId: null,
        },
        {
          key: 'HR-THERMAL',
          purpose:
            '在「烟气蔓延」问题中，用可见光或热成像方式观察可视范围内的温度分布及疑似异常位置，形成进一步核实的线索。',
          output: '建筑可见范围的热分布与待确认异常位置',
          formalCapabilityId: null,
        },
        {
          key: 'HR-INDOOR',
          purpose:
            '在「烟气蔓延」问题中，在适用且经允许的空间用遥控设备获取障碍、连通、可视区域和结构表面信息。',
          output: '可检查区域的门厅、通道或井道附近图像及障碍线索',
          formalCapabilityId: null,
        },
        {
          key: 'HR-COMMS',
          purpose:
            '在「烟气蔓延」问题中，在建筑内外、现场与后方之间提供合适的语音、图像和位置回传通路。',
          output: '现场观察人员与后方的烟气情况报告传递记录',
          formalCapabilityId: null,
        },
      ],
      sourceNature: '展示层编辑候选，不改变正式HRF-HZ/HRF-CR关联',
    },
    {
      issueKey: 'HR-ISSUE-02',
      title: '人员受困与疏散',
      description:
        '了解人员线索、楼层位置、通道状况和联络条件；不能通过通用研究资料断定实际人员状况。',
      capabilities: [
        {
          key: 'HR-SEARCH',
          purpose:
            '在「人员受困与疏散」问题中，在合适条件下结合热像、音视频与人工报告寻找需要进一步核实的人员线索。',
          output: '带来源及时间的人员线索，不等于已确认受困位置',
          formalCapabilityId: null,
        },
        {
          key: 'HR-SPACE',
          purpose:
            '在「人员受困与疏散」问题中，整理楼层、通道、楼梯间和局部障碍之间的空间关系，帮助了解需要核对的区域。',
          output: '楼层及通道空间关系与需要进一步确认的障碍',
          formalCapabilityId: null,
        },
        {
          key: 'HR-COMMS',
          purpose:
            '在「人员受困与疏散」问题中，在建筑内外、现场与后方之间提供合适的语音、图像和位置回传通路。',
          output: '人员状态及联络确认情况的语音/文字记录',
          formalCapabilityId: null,
        },
      ],
      sourceNature: '展示层编辑候选，不改变正式HRF-HZ/HRF-CR关联',
    },
    {
      issueKey: 'HR-ISSUE-03',
      title: '火势发展与蔓延',
      description: '整理火情可观察范围与时间变化，分开呈现观察线索和物理处置能力。',
      capabilities: [
        {
          key: 'HR-THERMAL',
          purpose:
            '在「火势发展与蔓延」问题中，用可见光或热成像方式观察可视范围内的温度分布及疑似异常位置，形成进一步核实的线索。',
          output: '可视区域火情外观与热分布的重复观察记录',
          formalCapabilityId: null,
        },
        {
          key: 'HR-REMOTE',
          purpose:
            '在「火势发展与蔓延」问题中，在满足设备和现场条件时，通过遥控平台在一定距离外承担特定物理操作。',
          output: '遥控处置设备可提供的功能与适用条件（不是自动调度）',
          formalCapabilityId: null,
        },
        {
          key: 'HR-COMMS',
          purpose:
            '在「火势发展与蔓延」问题中，在建筑内外、现场与后方之间提供合适的语音、图像和位置回传通路。',
          output: '火势变化报告在不同岗位间的传输记录',
          formalCapabilityId: null,
        },
      ],
      sourceNature: '展示层编辑候选，不改变正式HRF-HZ/HRF-CR关联',
    },
    {
      issueKey: 'HR-ISSUE-04',
      title: '建筑结构与防火分隔',
      description: '了解建筑空间构成、构件外观和防火分隔情况；设备观察与专业安全鉴定不可互相替代。',
      capabilities: [
        {
          key: 'HR-PLANS',
          purpose:
            '在「建筑结构与防火分隔」问题中，帮助查看建筑平面图、楼层功能、消防设施分布与管理资料，形成场景所需的信息清单。',
          output: '图纸中楼层分隔、设施和资料更新时间',
          formalCapabilityId: null,
        },
        {
          key: 'HR-MOVEMENT',
          purpose:
            '在「建筑结构与防火分隔」问题中，用合适的位移测量设备持续观察某一可见结构目标是否出现位移变化。',
          output: '选定受损构件的位移变化测量，不代表整体安全',
          formalCapabilityId: null,
        },
        {
          key: 'HR-SPACE',
          purpose:
            '在「建筑结构与防火分隔」问题中，整理楼层、通道、楼梯间和局部障碍之间的空间关系，帮助了解需要核对的区域。',
          output: '局部空间连通与图纸差异的待确认项',
          formalCapabilityId: null,
        },
      ],
      sourceNature: '展示层编辑候选，不改变正式HRF-HZ/HRF-CR关联',
    },
    {
      issueKey: 'HR-ISSUE-05',
      title: '高处坠物',
      description: '关注高处外墙、外装饰及构件可见异常，远程影像和监测结果只是专业核查线索。',
      capabilities: [
        {
          key: 'HR-THERMAL',
          purpose:
            '在「高处坠物」问题中，用可见光或热成像方式观察可视范围内的温度分布及疑似异常位置，形成进一步核实的线索。',
          output: '外立面可见热异常或火情线索，不能从热像判定坠物稳定性',
          formalCapabilityId: null,
        },
        {
          key: 'HR-MOVEMENT',
          purpose:
            '在「高处坠物」问题中，用合适的位移测量设备持续观察某一可见结构目标是否出现位移变化。',
          output: '选定高处构件的位移观察和必要告警线索',
          formalCapabilityId: null,
        },
        {
          key: 'HR-COMMS',
          purpose:
            '在「高处坠物」问题中，在建筑内外、现场与后方之间提供合适的语音、图像和位置回传通路。',
          output: '警戒范围与观察结果的传递记录',
          formalCapabilityId: null,
        },
      ],
      sourceNature: '展示层编辑候选，不改变正式HRF-HZ/HRF-CR关联',
    },
    {
      issueKey: 'HR-ISSUE-06',
      title: '疏散通道受阻',
      description:
        '了解出口、楼梯与通道的位置、障碍及信息来源。地图上存在路线并不代表现场通行安全。',
      capabilities: [
        {
          key: 'HR-INDOOR',
          purpose:
            '在「疏散通道受阻」问题中，在适用且经允许的空间用遥控设备获取障碍、连通、可视区域和结构表面信息。',
          output: '通道可检查部分的可见障碍线索',
          formalCapabilityId: null,
        },
        {
          key: 'HR-PLANS',
          purpose:
            '在「疏散通道受阻」问题中，帮助查看建筑平面图、楼层功能、消防设施分布与管理资料，形成场景所需的信息清单。',
          output: '已存疏散图纸中的通路及已知设施位置',
          formalCapabilityId: null,
        },
        {
          key: 'HR-COMMS',
          purpose:
            '在「疏散通道受阻」问题中，在建筑内外、现场与后方之间提供合适的语音、图像和位置回传通路。',
          output: '通行条件与核查结果的传递记录',
          formalCapabilityId: null,
        },
      ],
      sourceNature: '展示层编辑候选，不改变正式HRF-HZ/HRF-CR关联',
    },
  ],
} as const;
